"use client";

import { Button } from "@/components/ui/button";
import { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import parse, { DOMNode, Element } from "html-react-parser";
import { cn } from "@/lib/utils";

interface TypeProrpAccordion {
    content: string;
    bioDoctor?: string;
    titleDoctor: string;
    Icon?: React.ReactNode;
    styleIcon?: string;
}

export default function AccordionSpe({
    content,
    titleDoctor,
    Icon,
    styleIcon,
}: TypeProrpAccordion) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className={cn(
                "flex flex-col gap-4 duration-300 transition-max-height w-full p-4 pb-8 border_box_docid relative overflow-hidden",
                isOpen
                    ? "max-h-[1200px] duration-150"
                    : "max-h-[250px] brightness-bottom"
            )}
            id="section-3"
        >
            <div
                className={cn(
                    "flex items-end justify-center absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-white via-white/65 to-transparent transition-all duration-300 pointer-events-none",
                    isOpen && "h-0"
                )}
            ></div>
            <h2
                className={cn(
                    "text-black font-semibold text-xs lg:text-sm",
                    styleIcon
                )}
            >
                {titleDoctor}
            </h2>
            <div className="overflow-y-scroll text-justify">
                <div className="flex ml-2 text-[14px]">
                    <span className="mb-auto">{Icon}</span>
                    <div className="flex flex-col">
                        {parse(content ? content : "", {
                            replace: (node: DOMNode) => {
                                if (node instanceof Element) {
                                    if (node.attribs && node.attribs.style) {
                                        delete node.attribs.style;
                                    }
                                    return node;
                                }
                                return undefined;
                            },
                        })}
                    </div>
                </div>
            </div>

            <Button
                onClick={() => setIsOpen(!isOpen)}
                variant={"link"}
                className="text-center w-full left-0 absolute bottom-0 rounded-none bg-transparent bg-opacity-10"
            >
                <IoIosArrowDown
                    className={cn(
                        "text-2xl text-black transition-transform duration-300",
                        isOpen && "rotate-180"
                    )}
                />
            </Button>
        </div>
    );
}
